import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {DepartmentInterface} from '../interfaces/http.interface';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  public sharedLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor() { }
}
